import { render } from "./SportsAlertRow.vue?vue&type=template&id=81c91632&ts=true"
import script from "./SportsAlertRow.vue?vue&type=script&lang=ts"
export * from "./SportsAlertRow.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__